.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}
.pickers {
  display: flex;
  gap: var(--tuna-spacing-3);
  flex-wrap: wrap;
}
.pickerLabel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  font-size: var(--tuna-typography-body2-fontSize);
}
.pickerLabel select {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-borderRadius);
  border: 1px solid var(--tuna-border-default);
  background: var(--tuna-surface-default);
  color: var(--tuna-content-primary);
}
.pickerLabel select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
